import { useState } from "react";
import WorkCard from "@/components/feature/WorkCard";
import SectionHeading from "@/components/base/SectionHeading";
import { getWorksByType } from "@/utils/media";

export default function FeaturedWorks() {
  const [tab, setTab] = useState<"movie" | "tv">("movie");
  const list = getWorksByType(tab);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <SectionHeading
        eyebrow="Editor's Picks"
        title="精选影视作品推荐"
        desc="近期口碑与热度兼具的作品，封面、年份、类型标签与详情页资料一一对应，点开即可进入完整剧情导航。"
      >
        <div className="flex p-1 rounded-full bg-background-200/70 self-start md:self-auto">
          <button
            type="button"
            onClick={() => setTab("movie")}
            className={`px-1 py-1 rounded-full text-sm transition-colors cursor-pointer ${
              tab === "movie" ? "bg-primary-500 text-background-50" : "text-foreground-600"
            }`}
          >
            <span className="block px-4 py-1.5 whitespace-nowrap">电影</span>
          </button>
          <button
            type="button"
            onClick={() => setTab("tv")}
            className={`px-1 py-1 rounded-full text-sm transition-colors cursor-pointer ${
              tab === "tv" ? "bg-primary-500 text-background-50" : "text-foreground-600"
            }`}
          >
            <span className="block px-4 py-1.5 whitespace-nowrap">电视剧</span>
          </button>
        </div>
      </SectionHeading>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
        {list.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}